import Header from "@/site/components/Header";
import Footer from "@/site/components/Footer";
import CookieBanner from "@/site/components/CookieBanner";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Layout({ children }) {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        window.scrollTo(0, 0);
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return (
    <div className="min-h-screen" style={{ background: "#0E1116", color: "#E8ECF1" }}>
      <Header />
      <main className="pt-[68px]">{children}</main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
